import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

var cards_swipers = [];

function initialiseSwipers()
{
    cards_swipers.forEach(cards_swiper =>
    {
        if (cards_swiper instanceof Swiper)
        {
            cards_swiper.destroy(true, true);
        }
    });
    cards_swipers = [];

    document.querySelectorAll('section.icon-cards .icon-cards_cards').forEach((cards) => {
        const parent_section = cards.closest("section");
        const swiperEl = cards;
        const swiperElChild = cards.querySelector(".swiper");
        const wrapper = swiperEl?.querySelector(".swiper-wrapper");
        if (!swiperEl || !wrapper) return;

        // stash the original, un-paginated cards once
        if (!wrapper.dataset.originalCardsStored) {
            const originalCards = Array.from(wrapper.querySelectorAll('.icon-cards_cards_item'));
            wrapper.__originalCards = originalCards.map(c => c.cloneNode(true));
            wrapper.dataset.originalCardsStored = "true";
        }

        let autoplay = false;
        if (parent_section.classList.contains("autoplay")) {
            autoplay = { delay: 1600 };
        }

        if (parent_section.classList.contains("hide_navigation_arrows")) {
            cards.querySelector(".swiper-button-prev")?.remove();
            cards.querySelector(".swiper-button-next")?.remove();
        }

        // reset pagination breakpoint classes before re-evaluating this run
        swiperEl.classList.remove(
            "has-pagination-mobile",
            "has-pagination-mobile-landscape",
            "has-pagination-tablet",
            "has-pagination-desktop"
        );

        if (parent_section.classList.contains("hide_pagination_dots")) {
            cards.querySelector(".swiper-pagination")?.remove();
        }

        buildPagedSlides(wrapper);

        const swiper_options = {
            modules: [Navigation, Pagination, Autoplay],
            direction: 'horizontal',
            loop: false,
            rewind: true,
            autoplay: autoplay,
            speed: 700,
            slidesPerView: 1,   // each slide IS a full page/grid, nothing to miscalculate
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: cards.querySelector('.swiper-pagination'),
                clickable: true,
            },
        };

        const swiperInstance = new Swiper(swiperElChild, swiper_options);
        cards_swipers.push(swiperInstance);

        // now that Swiper has initialized, it has calculated whether
        // pagination is locked (single page) — check the REAL result
        if (!parent_section.classList.contains("hide_pagination_dots")) {
            const paginationEl = swiperElChild.querySelector(".swiper-pagination");
            if (paginationEl && !paginationEl.classList.contains("swiper-pagination-lock")) {
                swiperEl.classList.add("has-pagination-mobile");
                swiperEl.classList.add("has-pagination-mobile-landscape");
                swiperEl.classList.add("has-pagination-tablet");
                swiperEl.classList.add("has-pagination-desktop");
            }
        }
    });
}

function getGridConfig() {
    const width = window.innerWidth;

    if (width >= 1024) {
        return { cols: 4, rows: 4 }; // 16 per page
    }
    if (width >= 768) {
        return { cols: 3, rows: 4 }; // 12 per page
    }
    return { cols: 2, rows: 3 }; // 6 per page
}

function getCardsPerPage() {
    const { cols, rows } = getGridConfig();
    return cols * rows;
}

function getGridCols() {
    return getGridConfig().cols;
}

function buildPagedSlides(wrapper) {
    const perPage = getCardsPerPage();
    const cols = getGridCols();
    const originalCards = wrapper.__originalCards;
    if (!originalCards || !originalCards.length) return;

    wrapper.innerHTML = '';

    for (let i = 0; i < originalCards.length; i += perPage) {
        const pageCards = originalCards.slice(i, i + perPage);

        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        const grid = document.createElement('div');
        grid.className = 'icon-cards_grid';
        grid.style.display = 'grid';
        grid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;

        pageCards.forEach(card => grid.appendChild(card.cloneNode(true)));
        slide.appendChild(grid);
        wrapper.appendChild(slide);
    }
}

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        initialiseSwipers(); // rebuilds pages if breakpoint crossed
    }, 250);
});

document.addEventListener("DOMContentLoaded", () => {
    initialiseSwipers();
});